import React from 'react';
import { Switch, Space, Row, Col, Tooltip } from 'antd';
import TableFetchData from '../../components/data-table/TableFetchData';
import EditTableSvg from '../../assets/images/EditTable';
import DeleteTableSvg from '../../assets/images/DeleteTable';
import ViewTableSvg from '../../assets/images/ViewTable';
import { useTranslation } from 'react-i18next';
import TagTextComponent from '../../components/tag/TagTextComponent';
import { useNavigate } from 'react-router-dom';
import { ImageNo } from '../../components/image/ImageComponent';
import PaginationFetchData from '../../components/data-table/PaginationFetchData';
import ProductKnowledgePostCard from '../../components/productKnowledge/ProductKnowledgePostCard';

const TableListProductKnowledge = ({
  dataSource = [],
  viewType,
  setViewType,
  tableParams,
  setTableParams,
  getDataRequestAll,
  loading,
  setLoading,
  handleStatus,
  handleDelete,
  handleView,
}) => {
  const maxLength = 20;
  const navigate = useNavigate();
  const { t } = useTranslation();
  let condeLang = 'cn';

  const checktextByLang = (dataCode) => {
    let text = dataCode && dataCode[condeLang] && dataCode[condeLang].title ? dataCode[condeLang].title : '';
    const languages = dataCode ? Object.keys(dataCode) : [];
    if (!text) {
      for (let lang of languages) {
        if (dataCode && dataCode[lang] && dataCode[lang].title) {
          text = dataCode[lang].title;
          break;
        }
      }
    }
    return text;
  };

  const checktextByLangSub = (dataCode) => {
    let text = dataCode && dataCode[condeLang] && dataCode[condeLang].subtitle ? dataCode[condeLang].subtitle : '';
    const languages = dataCode ? Object.keys(dataCode) : [];
    if (!text) {
      for (let lang of languages) {
        if (dataCode && dataCode[lang] && dataCode[lang].subtitle) {
          text = dataCode[lang].subtitle;
          break;
        }
      }
    }
    return text;
  };

  const tableSettings = [
    {
      title: <label className="titleCard14400">{t('Cover')}</label>,
      render: (_, record) => (
        <img
          style={{ width: '110px', height: '74px', borderRadius: '6px', objectFit: 'cover' }}
          src={record.cover || ImageNo}
          alt={checktextByLang(record.localize)}
        />
      ),
    },
    {
      title: <label className="titleCard14400">{t('Title')}</label>,
      render: (_, record) => {
        const text = checktextByLang(record.localize);
        return (
          <Tooltip title={text}>
            {text.length > maxLength ? text.slice(0, maxLength) + '...' : text}
          </Tooltip>
        );
      },
    },
    {
      title: <label className="titleCard14400">{t('Description')}</label>,
      render: (_, record) => {
        const text = checktextByLangSub(record.localize);
        return (
          <Tooltip title={text}>
            {text.length > maxLength ? text.slice(0, maxLength) + '...' : text}
          </Tooltip>
        );
      },
    },
    {
      title: <label className="titleCard14400">{t('Read Time')}</label>,
      width: '100px',
      render: (_, record) => <>{record?.readingTime || 0}</>,
    },
    {
      title: <label className="titleCard14400">{t('Upload account')}</label>,
      dataIndex: 'account',
      key: 'account',
      render: (_, record) => {
        return (
          <label className="text-capitalize text-wrap-nowrap">
            {record?.createdBy?.name || record?.account || ''}
          </label>
        );
      },
    },
    {
      title: <label className="titleCard14400">{t('Operator')}</label>,
      key: 'action',
      render: (_, record) => {
        const recordId = record.productKnowledgeId || record.id || record._id;
        return (
          <Space size="middle">
            <Switch onChange={() => handleStatus(record)} checked={record.active} />
            <span
              onClick={() => navigate(`/products-knowledge/upload?productKnowledgeId=${recordId}`)}
              style={{ cursor: 'pointer' }}
              title={t('Edit')}
            >
              <EditTableSvg />
            </span>
            <span
              onClick={() => handleDelete(record)}
              style={{ cursor: 'pointer' }}
              title={t('Delete')}
            >
              <DeleteTableSvg />
            </span>
            <span
              onClick={() => handleView(record)}
              style={{ cursor: 'pointer' }}
              title={t('View')}
            >
              <ViewTableSvg />
            </span>
          </Space>
        );
      },
    },
  ];

  return (
    <div>
      <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
        <Col style={{ marginLeft: 'auto' }} />
      </Row>

      {viewType === 'table' ? (
        <TableFetchData
          rowKey={(record) => record.productKnowledgeId || record.id || record._id}
          tableParams={tableParams}
          setTableParams={setTableParams}
          data={dataSource}
          columns={tableSettings}
          loading={loading}
          setLoading={setLoading}
        />
      ) : (
        <>
          <ProductKnowledgePostCard
            tableParams={tableParams}
            setTableParams={setTableParams}
            dataSource={dataSource}
            columns={tableSettings}
            loading={loading}
            setLoading={setLoading}
            handleStatus={handleStatus}
            handleDelete={handleDelete}
            handleView={handleView}
          />
          <PaginationFetchData
            tableParams={tableParams}
            setTableParams={setTableParams}
          />
        </>
      )}
    </div>
  );
};

export default TableListProductKnowledge;
